<template>
  <div class="mx-15" v-if="$vuetify.breakpoint.smAndUp">
    <v-row class="font-weight-bold dark-grey--text">
      <v-col md="2">{{ $t('label.date') }}</v-col>
      <v-col md="2">{{ $t('label.time') }}</v-col>
      <v-col md="6">{{ $t('label.action') }}</v-col>
      <v-col md="2" class="text-right">{{ $t('label.points') }}</v-col>
    </v-row>

    <div v-for="(points, index) in historyList" :key="points.date">
      <v-row v-for="(list, index) in points.list" :key="index">
        <v-col md="2" class="font-weight-medium grey--text">{{ index === 0 ? date(list.date) : '' }}</v-col>
        <v-col md="2" class="font-weight-medium light-grey--text text--lighten-1">{{ list.time | shortTime }}</v-col>
        <v-col md="6" class="font-weight-medium">
          <p class="dark-grey--text">
            {{ list.transaction_type }}
            <!-- {{ list.transaction_type ? $t(`label.${list.transaction_type.replaceAll(' ', '')}`) : '' }} -->
          </p>
          <p class="text-subtitle-2 grey--text">
            {{ list.status }}
            <!-- {{
              list.status
                ? $t(`label.${list.status.indexOf('Transferred to') > -1 ? 'Transferredto' : list.status.replaceAll(' ', '')}`, {
                    name: list.status.replace(' ', '').replace('Transferredto', '')
                  })
                : ''
            }} -->
          </p>
        </v-col>
        <v-col md="2" class="text-right font-weight-medium primary--text text--darken-1">{{ list.points }}</v-col>
      </v-row>
      <v-divider v-if="index < historyList.length - 1" class="my-6"></v-divider>
    </div>
  </div>
  <div v-else>
    <v-card v-for="(transaction, i) in historyList" :key="i" class="my-4 white">
      <v-card-title class="primary--text text--darken-1 text-subtitle-1 pb-1 font-weight-medium">{{ transaction.date | shortDate('DD/MM/YYYY') }}</v-card-title>
      <v-card-text v-for="(record, j) in transaction.list" :key="j" class="pt-0">
        <div class="d-flex flex-row justify-space-between">
          <span>{{ record.time }}</span>
        </div>
        <div class="d-flex flex-row justify-space-between">
          <div class="d-flex flex-column">
            <span class="black--text font-weight-medium">{{ record.transaction_type ? $t(`label.${record.transaction_type.replaceAll(' ', '')}`) : '' }}</span>
            <span class="text-caption">
              {{
                $t(`label.${record.status.indexOf('Transferred to') > -1 ? 'Transferredto' : record.status.replaceAll(' ', '')}`, {
                  name: record.status.replace(' ', '').replace('Transferredto', '')
                })
              }}
            </span>
          </div>
          <span class="primary--text text--darken-1 font-weight-medium text-body">{{ record.points }}</span>
        </div>
        <span>{{ record.transaction_number }}</span>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['historyList'],
  methods: {
    date(dateString) {
      return this.$options.filters.shortDate(dateString, 'DD/MM/YYYY')
    }
  }
}
</script>
